var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "review-rating"
  }, [_c('div', {
    staticClass: "review-rating__row"
  }, [_c('div', {
    staticClass: "review-rating__rate-wrap"
  }, [_c('div', {
    staticClass: "review-rating__rate"
  }, [_c('div', {
    staticClass: "review-rating__rate-desktop"
  }, [_c('div', {
    staticClass: "review-rating__result"
  }, [_vm._v("\n            " + _vm._s(_vm.data.average) + "\n          ")]), _vm._v(" "), _c('TSProductRating', {
    attrs: {
      "is-active": _vm.data.average,
      "size": "24",
      "yellow": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "review-rating__count"
  }, [_vm._v("\n            " + _vm._s(_vm.convertRateText) + "\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "review-rating__rate-mobile"
  }, [_c('div', {
    staticClass: "review-rating__rate-mobile-col"
  }, [_c('div', {
    staticClass: "review-rating__title"
  }, [_vm._v("\n              Общий рейтинг\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "review-rating__count"
  }, [_vm._v("\n              " + _vm._s(_vm.convertRateText) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "review-rating__rate-mobile-col"
  }, [_c('TSProductRating', {
    attrs: {
      "is-active": _vm.data.average,
      "size": "20",
      "mobile-size": "18",
      "yellow": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "review-rating__result"
  }, [_vm._v("\n              " + _vm._s(_vm.data.average) + "\n            ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "review-rating__progress"
  }, _vm._l(_vm.list, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "review-rating__progress-item"
    }, [_c('div', {
      staticClass: "review-rating__progress-score"
    }, [_vm._v("\n          " + _vm._s(item.score) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "review-rating__progress-line-wrap"
    }, [_c('div', {
      staticClass: "review-rating__progress-line",
      style: {
        width: ((item.width) + "%")
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "review-rating__progress-count"
    }, [_vm._v("\n          " + _vm._s(item.count) + "\n        ")])]);
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "review-rating__add-review-wrap"
  }, [_c('div', {
    staticClass: "review-rating__add-review"
  }, [_vm._m(0), _vm._v(" "), _c('nuxt-link', {
    staticClass: "review-rating__link",
    attrs: {
      "to": _vm.link
    }
  }, [_c('Button', {
    staticClass: "review-rating__button review-rating__button_desktop"
  }, [_vm._v("\n            Написать отзыв\n          ")]), _vm._v(" "), _c('Button', {
    staticClass: "review-rating__button review-rating__button_mobile",
    attrs: {
      "fluid": ""
    }
  }, [_vm._v("\n            Оставить отзыв\n          ")])], 1)], 1)])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "review-rating__add-review-content"
  }, [_c('h5', {
    staticClass: "h5 mb-7"
  }, [_vm._v("\n            Оставьте отзыв о товаре\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "p mb-13"
  }, [_vm._v("\n            Поделитесь своими впечатлениями о товаре\n          ")])]);
}]

export { render, staticRenderFns }